import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props { children: ReactNode }
interface State { failed: boolean }

export class FeatureBoundary extends Component<Props, State> {
  state: State = { failed: false }
  static getDerivedStateFromError(): State { return { failed: true } }
  componentDidCatch(error: Error, info: ErrorInfo): void { console.error('Feature render failed', error, info) }
  render() {
    if (this.state.failed) return <div className="card"><h2>Trang này gặp lỗi</h2><p>Hãy thử tải lại trang. Các feature khác vẫn có thể dùng bình thường.</p><button className="button-secondary" onClick={() => this.setState({ failed: false })}>Thử lại</button></div>
    return this.props.children
  }
}
